// @ts-strict-ignore
import { TSection } from '@/shared/types/deprecated-types'

/**
 * Finds section with the specified ID value
 * @param categoryItems - All categories list
 * @param categoryId - Code to find
 */
export const getSectionById = (categoryItems: TSection[], categoryId: number | string): TSection =>
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	categoryItems.find(({ id }) => id.toString() === categoryId.toString())
